import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('NiotaClassic.DeviceMonitoring.title'),
      "subtitle": _vm.$i18n_t('NiotaClassic.DeviceMonitoring.subtitle')
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_vm.tabItem === 'tab-devices' ? [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-download",
            "disabled": !_vm.filteredList.length,
            "title": _vm.$i18n_t('NiotaClassic.DeviceMonitoring.downloadAsCsv')
          },
          on: {
            "click": _vm.runCSVExport
          }
        }), _c('core-split-button', [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-battery-quarter",
            "active": _vm.filterWarning,
            "title": _vm.$i18n_t('NiotaClassic.DeviceMonitoring.batteryWarning')
          },
          on: {
            "click": function ($event) {
              _vm.filterAlert = false;
              _vm.filterWarning = !_vm.filterWarning;
              _vm.filterThreshold = false;
            }
          }
        }), _c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-battery-slash",
            "active": _vm.filterAlert,
            "title": _vm.$i18n_t('NiotaClassic.DeviceMonitoring.batteryAlert')
          },
          on: {
            "click": function ($event) {
              _vm.filterAlert = !_vm.filterAlert;
              _vm.filterWarning = false;
              _vm.filterThreshold = false;
            }
          }
        }), _c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-sensor-alert",
            "active": _vm.filterThreshold,
            "title": _vm.$i18n_t('NiotaClassic.DeviceMonitoring.belowThreshold')
          },
          on: {
            "click": function ($event) {
              _vm.filterAlert = false;
              _vm.filterWarning = false;
              _vm.filterThreshold = !_vm.filterThreshold;
            }
          }
        }), _c('niota-classic-common-account-filter', {
          attrs: {
            "iconOnly": "",
            "n1Accounts": "",
            "initiallySelected": [_vm.accountId],
            "show-reset-button": false,
            "icon-only": ""
          },
          on: {
            "selected": accounts => {
              _vm.accountId = accounts.length ? accounts[0].id : undefined;
            },
            "reset-filter": () => {
              _vm.accountId = undefined;
              _vm.filterThreshold = false;
              _vm.filterAlert = false;
              _vm.filterWarning = _vm.tabItem === 'tab-gateways';
            }
          }
        })], 1)] : [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('NiotaClassic.GWMonitoring.alertForm.title'),
            "prepend-icon": "fa-cogs"
          },
          on: {
            "click": function ($event) {
              _vm.gwAlertNotificationDialog = true;
            }
          }
        }), _vm.gwHasNonEmptyList ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('NiotaClassic.GWMonitoring.loadMap'),
            "prepend-icon": "fa-map-marked"
          },
          on: {
            "click": function ($event) {
              return _vm.pushMapToRouter();
            }
          }
        }) : _vm._e(), _vm.gwHasNonEmptyList && (!_vm.permissions['super.system.manage'] || _vm.accountId) ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('NiotaClassic.GWMonitoring.visualization'),
            "prepend-icon": "fa-chart-bar"
          },
          on: {
            "click": function ($event) {
              _vm.gwVisualizationDialog = true;
            }
          }
        }) : _vm._e(), _c('core-split-button', [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-siren-on",
            "active": _vm.filterWarning,
            "title": _vm.$i18n_t('NiotaClassic.DeviceMonitoring.warningLevel')
          },
          on: {
            "click": function ($event) {
              _vm.filterWarning = !_vm.filterWarning;
              _vm.filterAlert = !_vm.filterWarning || _vm.filterAlert;
            }
          }
        }), _c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-exclamation-triangle",
            "active": _vm.filterAlert,
            "title": _vm.$i18n_t('NiotaClassic.DeviceMonitoring.alertLevel')
          },
          on: {
            "click": function ($event) {
              _vm.filterAlert = !_vm.filterAlert;
              _vm.filterWarning = !_vm.filterAlert || _vm.filterWarning;
            }
          }
        }), _c('niota-classic-common-account-filter', {
          attrs: {
            "iconOnly": "",
            "n1Accounts": "",
            "initiallySelected": [_vm.accountId],
            "show-reset-button": false,
            "icon-only": ""
          },
          on: {
            "selected": accounts => {
              _vm.accountId = accounts.length ? accounts[0].id : undefined;
            },
            "reset-filter": () => {
              _vm.accountId = undefined;
              _vm.filterThreshold = false;
              _vm.filterAlert = false;
              _vm.filterWarning = _vm.tabItem === 'tab-gateways';
            }
          }
        })], 1)]];
      },
      proxy: true
    }])
  }), _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', [_c(VCardText, {
    staticClass: "mt-0 pa-0"
  }, [_c(VTabs, {
    class: {
      sm: _vm.$vuetify.breakpoint.smAndDown
    },
    attrs: {
      "show-arrows": ""
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabsSlider, {
    attrs: {
      "color": _vm.color
    }
  }), _c(VTab, {
    attrs: {
      "href": "#tab-devices"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3"
  }, [_vm._v("fal fa-sensor-on")]), _vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceMonitoring.deviceMonitoring')) + "\n            ")], 1), _vm.hasGWMonitoringPermission ? _c(VTab, {
    attrs: {
      "href": "#tab-gateways"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3"
  }, [_vm._v("fal fa-router")]), _vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceMonitoring.gatewayMonitoring')) + "\n            ")], 1) : _vm._e(), _c(VTabsItems, {
    attrs: {
      "touchless": ""
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabItem, {
    key: "devices",
    attrs: {
      "value": "tab-devices"
    }
  }, [_c('niota-classic-device-monitoring-list', {
    ref: "list",
    attrs: {
      "accountId": _vm.accountId,
      "filterAlert": _vm.filterAlert,
      "filterWarning": _vm.filterWarning,
      "filterThreshold": _vm.filterThreshold,
      "resetFilter": _vm.resetFilter
    },
    on: {
      "filteredList": _vm.getFilteredList
    }
  })], 1), _vm.hasGWMonitoringPermission ? _c(VTabItem, {
    key: "gateways",
    attrs: {
      "value": "tab-gateways"
    }
  }, [_c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.gwVisualizationDialog,
      callback: function ($$v) {
        _vm.gwVisualizationDialog = $$v;
      },
      expression: "gwVisualizationDialog"
    }
  }, [_vm.gwVisualizationDialog ? _c('niota-classic-gw-mgmt-visualization', {
    attrs: {
      "accountId": _vm.accountId,
      "filterWarning": _vm.filterWarning,
      "filterAlert": _vm.filterAlert
    },
    on: {
      "close": function ($event) {
        _vm.gwVisualizationDialog = false;
      }
    }
  }) : _vm._e()], 1), _c(VDialog, {
    attrs: {
      "persistent": "",
      "max-width": "900"
    },
    model: {
      value: _vm.gwAlertNotificationDialog,
      callback: function ($$v) {
        _vm.gwAlertNotificationDialog = $$v;
      },
      expression: "gwAlertNotificationDialog"
    }
  }, [_vm.gwAlertNotificationDialog ? _c('niota-classic-gw-mgmt-alert-configs', {
    on: {
      "close": function ($event) {
        _vm.gwAlertNotificationDialog = false;
      }
    }
  }) : _vm._e()], 1), _c('niota-classic-gw-mgmt-list', {
    ref: "gwList",
    attrs: {
      "accountId": _vm.accountId,
      "filterWarning": _vm.filterWarning,
      "filterAlert": _vm.filterAlert,
      "editable": false
    },
    on: {
      "refreshed-list": function ($event) {
        _vm.gwHasNonEmptyList = _vm.$refs.gwList.gateways.length > 0;
      }
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };